import { render, staticRenderFns } from "./fashion.vue?vue&type=template&id=61bdd91c&scoped=true"
import script from "./fashion.vue?vue&type=script&lang=js"
export * from "./fashion.vue?vue&type=script&lang=js"
import style0 from "./fashion.vue?vue&type=style&index=0&id=61bdd91c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdd91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61bdd91c')) {
      api.createRecord('61bdd91c', component.options)
    } else {
      api.reload('61bdd91c', component.options)
    }
    module.hot.accept("./fashion.vue?vue&type=template&id=61bdd91c&scoped=true", function () {
      api.rerender('61bdd91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/trends/fashion.vue"
export default component.exports